<template>
  <div class="side-menu">
    <div class="logo-container">
      <img :src="logoUrl" class="logo-img" alt="System Logo" />
    </div>

    <el-menu
      :default-active="$route.path"
      :router="true"
      class="el-menu-vertical"
      text-color="#606266"
      active-text-color="#42b983"
      :unique-opened="true"
    >
      <el-menu-item index="/database">
        <i class="el-icon-s-home"></i>
        <span slot="title">数据库</span>
      </el-menu-item>

      <el-menu-item index="/biodiversity">
        <template slot="title">
          <i class="el-icon-s-data"></i>
          <span slot="title">生物多样性</span>
        </template>
      </el-menu-item>

      <el-submenu
        index="/system"
      >
        <template slot="title">
          <i class="el-icon-s-cooperation"></i>
          <span slot="title">生态系统服务</span>
        </template>

        <el-menu-item index="/system/carbon">碳储量</el-menu-item>
        <el-menu-item index="/system/list">土壤肥力</el-menu-item>
        <el-menu-item index="/system/stats">水源涵养</el-menu-item>
        <el-menu-item index="/system/production">生产能力</el-menu-item>
        <el-menu-item index="/system/concentration">负氧离子浓度</el-menu-item>
        <el-menu-item index="/system/culture">文化服务</el-menu-item>
        <el-menu-item index="/system/summary">多模块汇总</el-menu-item>
      </el-submenu>

      <el-menu-item index="/ecology">
        <i class="el-icon-files"></i>
        <span slot="title">生态系统服务权衡与协同</span>
      </el-menu-item>

      <el-menu-item index="/knowledge">
        <i class="el-icon-files"></i>
        <span slot="title">知识库</span>
      </el-menu-item>

      <el-menu-item index="/aiQa">
        <i class="el-icon-files"></i>
        <span slot="title">AI问答</span>
      </el-menu-item>

      <el-submenu index="/account">
        <template slot="title">
          <i class="el-icon-s-cooperation"></i>
          <span slot="title">权限管理</span>
        </template>
        <el-menu-item index="/permission/account">账号管理</el-menu-item>
        <el-menu-item index="/permission/role">角色管理</el-menu-item>
        <el-menu-item index="/permission/list">权限管理</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { getUserinfo } from "@/api/user/index";

export default {
  name: "SideMenu",
  data() {
    return {
      logoUrl: require("@/assets/logo.png"),
      // 1. 修改初始化：优先从本地存储获取，如果没有才用空数组
      roles: this.getStoredRoles(),
    };
  },
  mounted() {
    this.getUserinfo();
  },
  methods: {
    // 辅助方法：读取本地存储，防止 JSON.parse 报错
    getStoredRoles() {
      try {
        const stored = sessionStorage.getItem("USER_PERMISSIONS");
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        return [];
      }
    },

    getUserinfo() {
      getUserinfo()
        .then((res) => {
          if (res.code == 200) {
            // 确保数据结构存在
            if (res.data.roles && res.data.roles.length > 0) {
              const permissions = res.data.roles[0].permissions || [];

              // 2. 更新内存数据
              this.roles = permissions;

              // 3. 存入本地存储 (持久化)
              sessionStorage.setItem(
                "USER_PERMISSIONS",
                JSON.stringify(permissions)
              );
            }
          }
        })
        .catch((err) => {
          console.error("获取用户信息失败", err);
          // 如果接口报错（比如Token失效），可能需要清空本地权限防止显示错误菜单
          // sessionStorage.removeItem("USER_PERMISSIONS");
        });
    },

    hasPermission(slug) {
      if (!this.roles || this.roles.length === 0) return false;
      return this.roles.some((permission) => permission.slug === slug);
    },

    hasAnyPermission(slugsSlugList) {
      if (!this.roles || this.roles.length === 0) return false;
      return slugsSlugList.some((slug) => this.hasPermission(slug));
    },
  },
};
</script>
<style scoped>
.side-menu {
  height: 100%;
  background-color: #fff;
  border-right: 1px solid #e6e6e6;
  overflow-y: auto;
  width: 240px;
}

.logo-container {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f0f0;
  background-color: #f5f7fa;
}

.logo-img {
  max-width: 80%;
  max-height: 60px;
  object-fit: contain;
}

.el-menu {
  border-right: none;
}
.el-menu-item.is-active {
  background-color: #eafff5 !important;
  border-right: 3px solid #42b983;
}
.el-menu-item i {
  color: #909399;
}
.el-menu-item.is-active i {
  color: #42b983;
}
</style>
